import { render, staticRenderFns } from "./ResponsiveRowSmall.vue?vue&type=template&id=4c8feb8c&scoped=true"
import script from "./ResponsiveRowSmall.vue?vue&type=script&lang=ts"
export * from "./ResponsiveRowSmall.vue?vue&type=script&lang=ts"
import style0 from "./ResponsiveRowSmall.vue?vue&type=style&index=0&id=4c8feb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8feb8c",
  null
  
)

export default component.exports